module.exports = __webpack_public_path__ + "static/airqualitybt/images/markers_default.png";